var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueMarkdown',_vm._b({staticClass:"markdown",attrs:{"source":_vm.source}},'VueMarkdown',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }